export default function () {
    return { loadingValue: true, savedValue: false, spinnerStart: new Date() };
}